<template lang="pug">
  p.title(v-if="type==='title'") 
    slot(name="icon")
    span {{ text }}
  a.subtitle(v-else :href="'#'+ hash") {{ text }}
</template>
<script>
export default {
  name: 'TitleSection',
  props: {
    type: {
      type: String,
      default: "title",
    },
    text: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    hash: {
      type: String,
      default: "task-categories",
    }
  },
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 22px;
  font-weight: normal;
}

.subtitle {
  font-size: 20px;
  font-weight: 600;
  color: black;
  cursor: auto;
}
</style>
